<div class="technical-contacts">
  <div class="technical-contacts__header navigation__medium--m udex-mb-8">{{header}}</div>
  <div
    *ngIf="allowCreateNewContact"
    class="technical-contacts__button udex-mb-12 udex-mb-sm-8 udex-pt-12 udex-pt-sm-0"
  >
    <udex-button
      (click)="openModal()"
      size="Small"
      design="Secondary"
    >
      {{createNewContactText | cxTranslate}}
    </udex-button>
  </div>

  <ds-combo-box
    *ngIf="contacts?.length; else noContacts;"
    class="technical-contacts__contacts"
    data-cy="multiple-technical-contacts"
    (valueChange)="selectContacts($event)"
    [multiline]="true"
    [selectedHtml]='selectedContactData'
  >
    <ds-combo-box-dropdown
      #comboBox [initialValue]="[contacts[initialSelectedContact].uid]"
      [showSearchBar]="contacts?.length >= 10"
    >
      <ds-combo-box-dropdown-group maxHeight="12.5rem">
        <ds-combo-box-dropdown-option
          *ngFor="let contact of contacts" #dropdownOptions
          [value]="contact.uid"
          [label]="contact.name + contact.email"
          [isEditable]="isContactEditable"
          [isEditDisabled]="contact.isReplicated"
          [editButtonTooltip]="contact.isReplicated ? ('checkout.digitalNativeCheckout.editContact.tooltip.disabled' | cxTranslate) : null"
          (editClick)="onEditClick(contact)"
        >
          <span>
            <div [innerHTML]="contact.name"></div>
            <div class="ds-fine-print" [innerHTML]="contact.email"></div>
          </span>
        </ds-combo-box-dropdown-option>
      </ds-combo-box-dropdown-group>
    </ds-combo-box-dropdown>
  </ds-combo-box>
  <ng-template #noContacts>
    <div
      class="d-flex align-items-center technical-contacts__contacts no-contacts form-control__wrapper"
      data-cy="zero-technical-contact"
    >
      <div class="flex-grow-1 py-4 px-2 user-select-none"></div>
      <em class="flex- ds-icon ds-icon--arrow-down ds-icon--big p-2"></em>
    </div>
  </ng-template>
</div>
<dcp-technical-contacts-add-modal
  *ngIf="allowCreateNewContact"
  [contactType]="contactType"
  [openModal$]="openModal$"
  [header]="createNewContactText | cxTranslate"
  [submitButtonText]="actionButtonAlternativeText || createNewContactText"
  [contactRole]="newContactRole"
  (newContactCreated)="addNewContact($event); selectContacts([$event.uid])"
></dcp-technical-contacts-add-modal>
<dcp-technical-contacts-add-modal
  *ngIf="isContactEditable"
  [header]="editContactText | cxTranslate"
  submitButtonText="checkout.digitalNativeCheckout.edit.contact"
  [openModal$]=" openEditContactModal$"
  [contactRole]="newContactRole"
  [isEditModal]="isContactEditable"
  [contactToEdit]="contactToEdit"
  (contactUpdated)="updateContact($event)"
></dcp-technical-contacts-add-modal>
